import { Ellipsis } from "@visiblethread/react-components";
import clsx from "clsx";
import { DOC_SOURCE } from "constants/documents";
import { number, oneOf, string } from "prop-types";

import classes from "./DocumentFileName.module.scss";
import Flex, { GAP_CLASS } from "./Flex";
import { getDocumentIcon } from "./Modal/ChooseFilesModal/utils";

const DocumentFileName = ({
  className,
  fileName,
  source,
  tooltipDelay = 1000,
}) => {
  const icon = getDocumentIcon(fileName, source);

  return (
    <Flex
      className={clsx(className, classes.fileName)}
      data-testid="document-file-name"
      id={`docFileName-${fileName}`}
      gap={GAP_CLASS.GAP_100}
    >
      {Boolean(icon) && <span className={classes.icon}>{icon}</span>}

      <Ellipsis text={fileName} tooltipDelay={tooltipDelay} />
    </Flex>
  );
};

DocumentFileName.propTypes = {
  className: string,
  fileName: string,
  source: oneOf(Object.values(DOC_SOURCE)),
  tooltipDelay: number,
};

export default DocumentFileName;
